<template>
  <div :style="getBoxStyle">
    <img
      :style="getTipStyle"
      v-if="itemData.service.tipImg && showTip"
      :src="itemData.service.tipImg"
      alt=""
      @click="showTip = false"
    />
    <div :style="getBtnStyle" @click="handleLink(itemData.service.linkUrl)">
      {{ itemData.form.btnText }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showTip: true,
    };
  },
  watch: {
    itemData(val) {
      if (val.service.tipImg) {
        this.showTip = true;
      } else {
        this.showTip = false;
      }
    },
  },
  computed: {
    getBtnStyle() {
      const { service, padding, form } = this.itemData;
      return {
        color: form.btnColor,
        height: service.style.height + "px",
        width: service.style.width + "px",
        "font-size": "12px",
        "text-align": "center",
        overflow: "hidden",
        "line-height": service.style.height + "px",
        background: `${form.btnbg} url(${form.btnImg}) top center / 100% 100% no-repeat`,
        padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
        "background-size": "contain",
        "border-radius": form.isRound ? service.style.height + "px" : "0px",
      };
    },
    getBoxStyle() {
      const { service } = this.itemData;
      return {
        position: "fixed",
        "z-index": 9,
        top: service.style.top + "px",
        right: service.style.right + "px",
      };
    },
    getTipStyle() {
      const { service } = this.itemData;
      return {
        position: "absolute",
        "z-index": 9,
        top: service.tipTop + "px",
        right: service.tipRight + "px",
        width: service.tipWidth + "px",
        height:
          service.tipHeight == "auto"
            ? service.tipHeight
            : service.tipHeight + "px",
      };
    },
  },
  methods: {
    handleLink(url) {
      if (url) window.open(url, "_blank");
    },
  },
};
</script>

<style lang="sass" scoped></style>
